import { render, staticRenderFns } from "./InlineAlert.vue?vue&type=template&id=47045716&scoped=true"
import script from "./InlineAlert.vue?vue&type=script&lang=js"
export * from "./InlineAlert.vue?vue&type=script&lang=js"
import style0 from "./InlineAlert.vue?vue&type=style&index=0&id=47045716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47045716",
  null
  
)

export default component.exports